import { Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { ContentContainer, SkeletonLoader } from "./styled"
import { formatAmount } from "../../utils/formatters"
import BalanceIndicatorModal from "../Modal/BalanceIndicatorModal"
import { useGetUserInfo } from "../../api/hooks/useGetUserInfo"

export const AmountContainer = () => {
  const [open, setOpen] = useState(false)
  const {
    data: userInfo,
    isError,
    isLoadingError,
    isLoading,
    isInitialLoading,
    isRefetching,
  } = useGetUserInfo()
  const userBalance = userInfo?.balance?.availableAmount || "0"

  useEffect(() => {
    if (!isInitialLoading && !isRefetching) {
      setOpen(isError || isLoadingError)
    }
  }, [isError, isLoadingError, isInitialLoading])
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <ContentContainer>
        {isLoading ? (
          <SkeletonLoader
            animation="wave"
            variant="rounded"
            width={110}
            height={32}
          />
        ) : (
          <Typography variant="h3">{formatAmount(userBalance)} ₽</Typography>
        )}
      </ContentContainer>
      <BalanceIndicatorModal onClose={handleClose} open={open} />
    </>
  )
}
